/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

export interface SalesPlanGraph$Params {
  id: string;

  /**
   * Номер страницы для постраничного вывода данных графика.
   */
  page?: number;

  /**
   * Период агрегации. Допустимые значения: 'month', 'year'.
   */
  period?: 'month' | 'year';

  /**
   * ID продукта, для которого строится график.
   */
  product_id: number;
}

export function salesPlanGraph(
  http: HttpClient,
  rootUrl: string,
  params: SalesPlanGraph$Params,
  context?: HttpContext,
): Observable<
  BakendHttpResponse<{
    category: Array<string>;
    series: Array<{
      data: Array<number>;
      title: string;
      code: string;
    }>;
  }>
> {
  const rb = new RequestBuilder(rootUrl, salesPlanGraph.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('page', params.page, {});
    rb.query('period', params.period, {});
    rb.query('product_id', params.product_id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<{
        category: Array<string>;
        series: Array<{
          data: Array<number>;
          title: string;
          code: string;
        }>;
      }>;
    }),
  );
}

salesPlanGraph.PATH = '/api/project_calculations/sales_plan/graph/{id}/';
